import { USER_ROLES } from '../../auth/index';

const PERMISSIONS = Object.values(USER_ROLES);

export default {
	PROFILE: {
		ACTIVE: true,
		NAME: 'profile',
		LABEL: 'Profile',
		ICON: 'user-default',
		PATH: '/profile',
		PERMISSIONS,
	},
};
